import { render, staticRenderFns } from "./editCoupon.vue?vue&type=template&id=2d9b98c6&scoped=true&"
import script from "./editCoupon.vue?vue&type=script&lang=js&"
export * from "./editCoupon.vue?vue&type=script&lang=js&"
import style0 from "./editCoupon.vue?vue&type=style&index=0&id=2d9b98c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9b98c6",
  null
  
)

export default component.exports